module.exports = __webpack_public_path__ + "static/img/suralertImg.1553a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suralertImg.png
// module id = E/LQ
// module chunks = 1